import { useEffect } from 'react';

import { useNavParams } from 'hooks';
import { useTabNavigation } from 'hooks/useTabNavigation';
import { useTranslation } from 'react-i18next';
import { HashRouter } from 'react-router-dom';
import { Route } from 'react-router-dom';

import { Paper, Tab, Tabs } from '@mui/material';

import StyledTabs from 'components/shared/StyledTabs';

import EditProjectPage from './Projects/EditProjectPage/EditProjectPage';
import { pages } from './tabs';

const PAGE = 'roster,administrator';

const Administrator = () => {
  const { t } = useTranslation('common');
  const [tabIndex, setTabIndex] = useTabNavigation(pages);

  const handleChange = (e) => {
    setTabIndex(e.target.tabIndex);
  };

  const { params, setParams } = useNavParams();

  useEffect(() => {
    if (params && !params?.page) {
      setParams({ page: 'PROJECTS' });
    }
  }, [params]);

  return (
    <StyledTabs className="tabs">
      <Paper square sx={{ zIndex: 50 }}>
        <Tabs
          variant="scrollable"
          allowScrollButtonsMobile
          value={tabIndex}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
        >
          {pages.map((page, index) => (
            <Tab
              key={index}
              component="a"
              tabIndex={index}
              label={t(`${page.name.toLowerCase()}`)}
              href={`/#${PAGE}&page=${page.name.toLowerCase()}`}
            />
          ))}
        </Tabs>
      </Paper>
      <div style={{ padding: 30, overflowY: 'auto' }}>
        <HashRouter hashType="noslash" baseName={'/'}>
          {pages.map((page, key) => {
            return (
              <Route
                key={key}
                path={`/${PAGE}&page=${page.name.toLowerCase()}`}
                component={page.Component}
              />
            );
          })}
          <Route
            path={`/${PAGE}&page=PROJECTS&projectId=:projectId`}
            component={(props) => (
              <EditProjectPage projectEntityId={props.match.params.projectId} />
            )}
          />
        </HashRouter>
      </div>
    </StyledTabs>
  );
};

export default Administrator;
